
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cms"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CP_Page"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"cms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cms"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageBase"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageCategoryFilters"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageCategory"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageTags"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageMetas"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sections"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionBase"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImages"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionShopCategories"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionEventCategories"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionCategories"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionTags"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionShopTags"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionFileTags"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionRestrictionMemberTags"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionProducts"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionArticles"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionPages"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionRows"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionColumns"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionGridArea"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionGridAreas"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionContents"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionInformations"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionSettings"},"directives":[]}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageHyperlink"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageExtension"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageMarketingCampaign"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1008}};
    doc.loc.source = {"body":"#import \"../fragments/Page.gql\"\n#import \"../fragments/Section.gql\"\n\nquery FetchPage($id: Int!, $cms: Int) {\n    CP_Page(id: $id, cms: $cms) {\n        ...PageBase\n        ...PageCategoryFilters\n        ...PageCategory\n        ...PageTags\n        ...PageMetas\n        # ...PageSections\n        sections {\n            ...SectionBase\n            ...SectionImages\n            ...SectionShopCategories\n            ...SectionEventCategories\n            ...SectionCategories\n            ...SectionTags\n            ...SectionShopTags\n            ...SectionFileTags\n            ...SectionRestrictionMemberTags\n            ...SectionProducts\n            ...SectionArticles\n            ...SectionPages\n            ...SectionRows\n            ...SectionColumns\n            ...SectionGridArea\n            ...SectionGridAreas\n            ...SectionContents\n            ...SectionInformations\n            ...SectionSettings\n        }\n        ...PageHyperlink\n        ...PageExtension\n        ...PageMarketingCampaign\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/Page.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/Section.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["FetchPage"] = oneQuery(doc, "FetchPage");
        
